import { apiKeySelector } from 'store/appSettings/selectors';
import { Thunk } from 'store/types';
import { dfdAccessTokenSelector } from './selectors';
import { fetchTPSTokenForSource, checkAuthSources } from './tpsHelpers';
import { setAuthStatusTPS } from './actions';
import { AuthLiteRequest } from './types';

export const FETCH_TPS_TOKEN = 'AUTH.FETCH_TPS_TOKEN';
export const FETCH_TPS_TOKEN_SUCCESS = 'AUTH.FETCH_TPS_TOKEN_SUCCESS';
export const FETCH_TPS_TOKEN_FAIL = 'AUTH.FETCH_TPS_TOKEN_FAIL';

export const fetchTokenForSource = (source: string): Thunk => async (dispatch, getState) => {
  const dfdToken = dfdAccessTokenSelector(getState());
  const apiKey = apiKeySelector(getState());
  dispatch({
    type: FETCH_TPS_TOKEN,
    payload: {
      source
    }
  });

  if (!dfdToken || !apiKey) {
    dispatch({
      type: FETCH_TPS_TOKEN_FAIL,
      payload: {
        source
      },
      error: new Error('No tokens found')
    });
  }

  try {
    const tokenResponse = await fetchTPSTokenForSource(source, { token: dfdToken, apiKey });

    dispatch({
      type: FETCH_TPS_TOKEN_SUCCESS,
      payload: {
        source,
        data: tokenResponse
      }
    });
  } catch (error) {
    dispatch({
      type: FETCH_TPS_TOKEN_FAIL,
      payload: { source },
      error
    });
  }
};

export const getTPSAuthStatus = (): Thunk => async (dispatch, getState) => {
  const state = getState();
  const apiKey = apiKeySelector(state);
  const token = dfdAccessTokenSelector(state);

  const results = await checkAuthSources({ token, apiKey });

  dispatch(setAuthStatusTPS(results));
};

// web only
export const HIDE_GUEST_BENEFITS_MODAL = 'AUTH.HIDE_GUEST_BENEFITS_MODAL';
export const hideGuestBenefitsModal = () => ({
  type: HIDE_GUEST_BENEFITS_MODAL
});

export const TOGGLE_PROTECTED_ROUTE_MODAL = 'AUTH.TOGGLE_PROTECTED_ROUTE_MODAL';
export const toggleProtectedRouteModal = () => ({
  type: TOGGLE_PROTECTED_ROUTE_MODAL
});

export const AUTH_LITE_LOGIN = 'AUTH.AUTH_LITE_LOGIN';
export const AUTH_LITE_LOGIN_FAIL = 'AUTH.AUTH_LITE_LOGIN_FAIL';
export const AUTH_LITE_LOGIN_SUCCESS = 'AUTH.AUTH_LITE_LOGIN_SUCCESS';

export const authLiteLogin = (data: AuthLiteRequest) => ({
  type: AUTH_LITE_LOGIN,
  payload: {
    client: 'tps',
    request: {
      method: 'post',
      url: '/authlite.jwt',
      data
    }
  }
});
